// PLUGINS IMPORTS //
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import ProjectItem from './ProjectItem/ProjectItem'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //

// REDUX
import { getProjectsSelector } from 'Redux/Selectors/ProjectsSelectors'
import { getProjectsThunkCreator } from 'Redux/Reducers/ProjectsReducer'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const PortfolioScreen: React.FC<PropsType> = () => {
  let projects = useSelector(getProjectsSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getProjectsThunkCreator())
  }, [])

  return (
    <Wrapper>
      {/* {[
        {
          title: "learningworld",
          type: "car shit",
          tech: "React",
          ID: 32,
          description: "I am a lorem lorem ipsum prem lorem",
          technologies: ["React"],
          features: [],
        },
        {
          title: "learningworld",
          type: "car shit",
          tech: "React",
          ID: 32,
          description: "I am a lorem lorem ipsum prem lorem",
          technologies: ["React"],
          features: [],
        },
        {
          title: "learningworld",
          type: "car shit",
          tech: "React",
          ID: 32,
          description: "I am a lorem lorem ipsum prem lorem",
          technologies: ["React"],
          features: [],
        },
        {
          title: "learningworld",
          type: "car shit",
          tech: "React",
          ID: 32,
          description: "I am a lorem lorem ipsum prem lorem",
          technologies: ["React"],
          features: [],
        },
      ].map((item) => (
        <ProjectItem key={item.title} project={item} />
      ))} */}

      <h3>No projects have been published yet</h3>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

export default React.memo(PortfolioScreen, memoComparison)
